module.exports = __webpack_public_path__ + "static/mielona_stojaca-abbe3a66c4d43b70289f2020d025e31d.png";